import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../../../components/Modal';
import SkeletonGrid from '../../../../../../../components/SkeletonLoader/SkeletonGrid';
import { Form } from 'react-bootstrap';

const CRStudentResponse = ({
  isOpen,
  onClose,
  studentResponse,
  isLoading
}) => {
  const [showStudentName, setShowStudentName] = useState(false);
  const answerCellRefs = useRef([]);

  useEffect(() => {
    if (!window.MathJax) return;
 
    const elements = answerCellRefs.current.filter(Boolean);
    if (elements.length) {
      window.MathJax.typesetPromise(elements);
    }
  }, [studentResponse, isLoading]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      titleName={'Student Response'}
      contentWidth='70%'
    >
      {isLoading ? (
        <SkeletonGrid
          rowCount={4}
          colCount={2}
        />
      ) : (
        <>
          <div className='d-flex justify-content-end mb-4'>
            <div>
              <Form.Check
                type="checkbox"
                label="Show Student Name"
                id="showStudentName"
                checked={showStudentName}
                onChange={() => setShowStudentName(!showStudentName)}
              />
            </div>
          </div>
          <table className='table reportTable'>
            <thead>
              <tr>
                <th>Student</th>
                <th>Response</th>
              </tr>
            </thead>
            <tbody>
              {studentResponse.map((item, index) => (
                <tr key={index}>
                  <td className='col-6'>{showStudentName ? item.studentLastName + ' ' + item.studentFirstName : 'name hidden'}</td>
                  <td><div ref={(elem) => (answerCellRefs.current[index] = elem)} dangerouslySetInnerHTML={{ __html: item.answer }}></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      )}
    </Modal>
  );
};

CRStudentResponse.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  studentResponse: PropTypes.array,
  isLoading: PropTypes.bool
};

export default CRStudentResponse;
